module.exports = __webpack_public_path__ + "media/images/header-stripes-9d56b30138493a9c4d207b9e6fd7cdd3.png";